
    import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
    import moment from 'moment';
    import { mapActions, mapState } from 'vuex';
    import { PatientenauswertungFilter } from '@/store/patientenauswertung';
    import { LoadReisezielePayload } from '@/store/reiseziele';

    @Component({
        computed: {
            ...mapState('impfstoff', ['impfstoffe']),
            ...mapState('impfstoff', { loadersImpfstoff: 'loaders' }),
            ...mapState('reise', ['reiseziele']),
            ...mapState('reise', { reiseLoaders: 'loaders' }),
        },
        methods: {
            ...mapActions('impfstoff', ['loadImpfstoffe']),
            ...mapActions('reise', ['loadReiseziele']),
        },
    })
    export default class PatientenauswertungFilterDialog extends Vue {
        @Prop() visible!: boolean;
        @Prop({
            default: () => ({
                zeitraum: [
                    moment().format('YYYY-MM-DD'),
                    moment().format('YYYY-MM-DD'),
                ],
                impfstoffe: [],
                reiseziele: [],
                jahrgang: ['1960', '2000'],
            }),
        }) filterProp!: PatientenauswertungFilter;

        public loadImpfstoffe!: () => void;
        public loadReiseziele!: (payload?: LoadReisezielePayload) => void;
        public search = '';

        public filter: Partial<PatientenauswertungFilter> = {};
        public previousFilter: Partial<PatientenauswertungFilter> = {};
        public zeitraumMenu = null;

        public mounted(): void {
            this.filter = this.filterProp;
        }

        public updated(): void {
            this.filter = this.filterProp;
        }

        @Watch('visible')
        public onChangeVisible(visible: boolean): void {
            if (visible) {
                this.loadImpfstoffe();
                this.loadReiseziele();
                this.previousFilter = { ...this.filter };
            }
        }

        public get maxZeitraum(): string {
            return moment().format('YYYY-MM-DD');
        }

        public get maxJahrgang(): number {
            return moment().year();
        }

        public get zeitraumLabel(): string {
            return this.filter.zeitraum?.length
                ? this.filter.zeitraum?.sort((a: string, b: string) => a.localeCompare(b)).map((date: string) => {
                    const [year, month, day] = date.split('-');
                    return `${day}.${month}.${year}`;
                }).join(' - ')
                : '';
        }
    }
